export default {
  Email: 1,
  Webhook: 2,
  AS2: 3,
  FTP: 4,
  SFTP: 5,
};



// WEBPACK FOOTER //
// ./src/modules/organization/models/LegacyNotificationChannelTypeId.ts